import React, { useState, useEffect } from "react";
import { useEditorGroups } from "../hooks/useMyEditorGroups";
import { useGroupSearch } from "../hooks/useGroupSearch";
import {
	Container,
	Row,
	Col,
	Form,
	Button,
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	Card,
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	Image,
	Badge,
} from "react-bootstrap";
import "./EventGroups.css";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { api_s2 } from "../config";
import { Loader } from "../components/Loader";
// Limit the number of group members per group that can be selected
const GROUP_SIZE_LIMIT = 5000;

type GroupData = {
	id: string;
	_id: string;

	label: string;
	type: string;
};
type EventData = {
	_id: string;
	Title: string;
};
interface EventGroupProps {
	initialData: GroupData[];
	eventData: EventData;
	groupTypes: string[];
	onValueChange: (data: string[]) => void;
}

export const EventGroups: React.FC<EventGroupProps> = ({
	initialData,
	eventData,
	groupTypes,
	onValueChange,
}) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { getData, groups, groupTypes: hookGroupTypes, groupsLoaded } = useEditorGroups([]);
	const {
		groupSearchResult,
		groupSearchResultLoaded,
		groupSearchFilter,
		setGroupSearchFilter,
	} = useGroupSearch();
	const [selectedGroupsObj, setSelectedGroupsObj] =
		useState<GroupData[]>(Array.isArray(initialData) ? initialData : []);
	const [filteredGroups, setFilteredGroups] = useState<GroupData[]>(groups);

	const [selectedGroups, setSelectedGroups] = useState<string[]>(
		Array.isArray(initialData) ? initialData.map((obj) => obj._id) : []
	);
	const [selectedGroupType, setSelectedGroupType] = useState("all");
	const [selectedGroupFave, setSelectedGroupFave] = useState("common");
	const [searchQuery, setSearchQuery] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const DEFAULT_GROUP_ICON =
		"https://pymblelc.blob.core.windows.net/assets/pymble-p.png";

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleGroupTypeChange = (e: any) => {
		setSelectedGroupType(e.target.value);
	};
	const onRemoveGroup = (group_id: string) => {
		if (!group_id) return;
		let newGroupArray = selectedGroups.filter((item) => item !== group_id);
		let newGroupsObj = selectedGroupsObj.filter((obj) => obj._id !== group_id);
		setSelectedGroups(newGroupArray);
		setSelectedGroupsObj(newGroupsObj);
	};
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleCreateNotice = (_e: any) => {
		const url =
			"https://notices.pymblelc.nsw.edu.au/notices?event_id=" +
			eventData._id +
			"&group_id=" +
			selectedGroups +
			"&title=" +
			encodeURIComponent(removeHtmlEntities(eventData.Title.toString()));
		return window.open(url, "_blank");
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleGroupCombo = (e: any) => {
		const selectedOption = e.target.options[e.target.selectedIndex];
		console.log(selectedOption.getAttribute("data-icon"));
		console.log(selectedOption.text);
		console.log("Value: ", e.target);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		setSelectedGroups((n: any) => [...n, e.target.value]);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		setSelectedGroupsObj((n: any) => [
			...n,
			{
				_id: e.target.value,
				Label: selectedOption.text,
				Members: [],
				Icon: selectedOption.getAttribute("data-icon"),
				MemberCount: 0,
			},
		]);
		// if (ref.current) ref.current.clear();
		console.log("Selected groups: ", selectedGroups);
		console.log("Selected groups obj: ", selectedGroupsObj);
	};

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const filterGroupTypes = (type: string) => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		let filteredGroupArray: GroupData[] = groups.filter((group: any) => {
			return group["type"] === type || type === "all";
		});

		setFilteredGroups(filteredGroupArray);
	};

	useEffect(() => {
		handleSearch();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedGroupType, searchQuery]);

	useEffect(() => {
		onValueChange(selectedGroups);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedGroups]);

	useEffect(() => {
		setIsLoading(!groupSearchResultLoaded);
	}, [groupSearchResultLoaded]);

	useEffect(() => {
		setFilteredGroups(groupSearchResult);
		handleGroupFaves(selectedGroupFave);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [groupSearchResult]);

	function removeHtmlEntities(data: string): string {
		const parser = new DOMParser();
		const decodedHtml = parser.parseFromString(data, "text/html");
		return decodedHtml.documentElement.textContent || "";
	}
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleSearchInput = (e: any) => {
		setSearchQuery(e.target.value);
	};
	const handleSearch = async () => {
		setIsLoading(true);
		const filter = {
			search: searchQuery,
			type: selectedGroupType === "all" ? [] : [selectedGroupType],
			limit: 50,
			active_only: 1,
			mbr_size_limit: GROUP_SIZE_LIMIT,
			g: "",
		};
		const newSearch = { ...groupSearchFilter, ...filter };
		setGroupSearchFilter(newSearch);
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleGroupFaves = (val: any) => {
		const filterValue = val;
		if (filterValue === "common") {
			const filteredGroupsData = groupSearchResult.filter(
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				(group: any) => group.Favourite === true
			);
			setFilteredGroups(filteredGroupsData);
		} else {
			setFilteredGroups(groupSearchResult);
		}
		setSelectedGroupFave(filterValue);
	};

	return (
		<Container className="groupsContainer">
			<Row className="mb-3">
				<Col className="col-md-12">
					<h3>Groups</h3>
					<p>
						Groups added here will be able to see the event in their calendar
					</p>
				</Col>
			</Row>
			<Row className="mb-3">
				<Col className="col-md-3">
					<Form.Label htmlFor="">Filter by group type</Form.Label>
					<Form.Select
						className="groupTypeSelect"
						value={selectedGroupType}
						onChange={handleGroupTypeChange}
						htmlSize={12}
					>
						<option value="all">All</option>
						{groupTypes && groupTypes.length > 0 &&
							// eslint-disable-next-line @typescript-eslint/no-explicit-any
							groupTypes.map((type: any, index: any) => (
								<option key={index} value={type["id"]}>
									{type["value"]}
								</option>
							))}
					</Form.Select>
				</Col>
				<Col className="groupSelectContainer">
					<Form.Label>Find a group:</Form.Label>
					<Form.Control
						onChange={handleSearchInput}
						ref={(input: HTMLInputElement | null) => {
							// eslint-disable-next-line @typescript-eslint/no-unused-expressions
							input && input.focus();
						}}
					></Form.Control>
					<div key={`inline-radio`} className="mb-3">
						<Form.Check
							inline
							label="all groups"
							name="group1"
							type={"radio"}
							id={`inline-radio-1`}
							onChange={() => handleGroupFaves("all")}
							value="all"
							checked={selectedGroupFave === "all"}
						/>
						<Form.Check
							inline
							label="commonly used groups"
							name="group1"
							type={"radio"}
							id={`inline-radio-2`}
							onChange={() => handleGroupFaves("common")}
							value="common"
							checked={selectedGroupFave === "common"}
						/>
					</div>
					<Form.Select
						className="groupSelect"
						onChange={handleGroupCombo}
						htmlSize={8}
					>
						{filteredGroups.length > 0 &&
							// eslint-disable-next-line @typescript-eslint/no-explicit-any
							filteredGroups.map((type: any, index: any) => (
								<option key={index} data-icon={type["Icon"]} value={type["id"]}>
									{type["Name"]["Short"]}
								</option>
							))}
					</Form.Select>
					{isLoading && <Loader />}
				</Col>
				<Col className="col-md-2 text-right">
					<Button
						className="float-right"
						type="button"
						variant="primary"
						id="create_group_notice"
						onClick={handleCreateNotice}
						disabled={selectedGroups.length > 0 ? false : true}
						size="sm"
						title="Create notice for these groups"
					>
						Create Group Notice
					</Button>
				</Col>
			</Row>
			<Row className="mb-3">
				<Col className="col-md-10">
					<h4>Selected groups</h4>
					<div id="selectedGroupsContainer">
						{/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
						{selectedGroupsObj.map((group: any, index: number) => (
							<Badge key={index} bg="secondary">
								{group.Label}{" "}
								<span
									title="Remove group"
									onClick={() => onRemoveGroup(group._id)}
								>
									x
								</span>
							</Badge>
						))}
					</div>
				</Col>
			</Row>
			{/* <Row className="mb-3">
				<Col className="col-md-6">
					{selectedGroupsObj.map((group: any, index: any) => (
						<Card body key={index} className="mt-1">
							<Image
								className="group-icon"
								srcSet={group.Icon || DEFAULT_GROUP_ICON}
								roundedCircle
							/>
							{group.Label}
							<span
								className="float-right remove-group-btn"
								title="Remove group"
								onClick={() => onRemoveGroup(group._id)}
							></span>
						</Card>
					))}
				</Col>
			</Row> */}
		</Container>
	);
};
